import { Navigate, useLocation } from "react-router-dom";

const ParentProtectedRoute = ({ children }) => {
  const location = useLocation();
  // const token = localStorage.getItem("token");
  const token = localStorage.getItem("parentAuth");

  return token ? children : <Navigate to="/parent/login" state={{ from: location }} replace />;
};

export default ParentProtectedRoute;